module.exports = __webpack_public_path__ + "static/2-56efcd14ddb78a000608fcb1884d13bb.svg";